module.exports = require("@gauzy/plugin-posthog");